import React, { Component } from 'react';
import Markdown from 'react-markdown'

class Contact extends Component {
    constructor(props) {
        super(props);
        this.state = {
            contactOpen: false
        }
        this.contactClick = this.contactClick.bind(this);
    }


    contactClick(){
        this.setState({
            contactOpen: !this.state.contactOpen
        });

        if (this.state.contactOpen === false){
            document.getElementById("contactTxt").innerHTML = "Close";
        } else {
            document.getElementById("contactTxt").innerHTML = "Contact";
        }
    }

  
    render(){
        const contactinfo = 
            <div id="contactInfo">
                <div>
                    <span><a href={"mailto:" + this.props.details.email} className="menuTriggerInner">{this.props.details.email}</a></span>
                </div>
                <div>
                    <span><Markdown source={this.props.details.agentInfo} /></span>
                </div>
                <div>
                    <span><a href={"mailto:"+this.props.details.agentEmail} className="menuTriggerInner">{this.props.details.agentEmail}</a></span>
                </div>
                <div>
                    <span><Markdown source={this.props.details.instagram} /></span>
                </div>
            </div>
        return (
        <div id="contact">
            <div id="contactTxt" className={ this.state.contactOpen ? "menuTriggerInner open" : "menuTriggerInner" } onClick={this.contactClick}>Contact</div>
            { this.state.contactOpen ? contactinfo : null }
        </div>
        )
    }
}


export default Contact;


// WEBPACK FOOTER //
// ./src/Contact.js